// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { currencyMenuStyles } from "@sc/Overrides/Widgets/Common/CurrencyMenu";
import Currency from "@sc/XDL/Icons/Currency";
import { color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

currencyMenuStyles.currencySymbol = {
    size: 14,
    src: Currency,
    color: "common.ui1",
    css: css`
        margin-right: 8px;
        margin-bottom: 2px;
        opacity: 0.66;
    `,
};

currencyMenuStyles.currencySelect = {
    iconProps: {
        css: css`
            display: none;
        `,
    },
    css: css`
        &&&&& {
            border: none;
            background-color: ${color("common.ui9")};
            text-transform: uppercase;
            padding: 0;
            font-size: 14px;
            line-height: 22px;
            font-weight: bold;
            color: ${color("common.white")};
            height: 22px;
            cursor: pointer;
            padding-right: 0;
        }
        &&&&&&:hover {
            border: none;
        }
        &:focus {
            padding: 0;
        }
    `,
};

currencyMenuStyles.currencyWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};
